import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { ToastProvider } from '@uhg-abyss/web/ui/Toast';
import { PropsContext } from '@uhg-abyss/web/hooks/usePropsContext/PropsContext';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { ProviderSelectDrawer } from './ProviderSelectDrawer';

const theme = createTheme('uhc', { enterpriseFont: true });
export const Widget = (props) => {
  const widgetProps = { ...props };
  return (
    <ThemeProvider theme={theme}>
      <PropsContext.Provider value={widgetProps}>
        <ToastProvider />
        <ProviderSelectDrawer {...props} />
      </PropsContext.Provider>
    </ThemeProvider>
  );
};

Widget.displayName = 'utility/ProviderSelectDrawer';

Widget.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    isProviderOpen: PropTypes.bool,
    toggleProvider: PropTypes.func,
    user: PropTypes.shape({}).isRequired,
    saveDisabled: PropTypes.bool,
  }),
  events: PropTypes.shape({}),
};

Widget.defaultProps = {
  data: {
    title: 'Provider Select Drawer',
  },
  events: null,
};
